import AbstractMappingValidator from './abstract-mapping-validator';
import ActionService from '../../service/mapping/action-service';
export default class ActionValidator extends AbstractMappingValidator {
    constructor() {
        super(...arguments);
        this.index = null;
    }
    validate(action) {
        this.errors = {};
        if (!action) {
            return this.errors;
        }
        this.validateType(action, this.errors);
        this.validateValue(action, this.errors);
        this.validateSeparator(action, this.errors);
        this.validateWith(action, this.errors);
        return this.errors;
    }
    validateType(action, validationErrors) {
        if (!action) {
            return;
        }
        const errors = [];
        if (!ActionService.TYPES.includes(action.type)) {
            errors.push(this.i18n.t('mapping.validation.please_select_type').toString());
        }
        else if (this.index === 0 && action.type !== 'take') {
            errors.push(this.i18n.t('mapping.validation.first_action_type').toString());
        }
        if (errors.length > 0) {
            validationErrors.type = errors;
        }
    }
    validateValue(action, validationErrors) {
        if (!action || !action.type) {
            return;
        }
        if (ActionService.STANDALONE_TYPES.includes(action.type)) {
            return;
        }
        let errors = [];
        if (action.valueSettings && Object.keys(action.valueSettings).length) {
            errors = this.validateValueSettings(action.valueSettings, validationErrors);
        }
        else {
            errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
        }
        if (errors.length > 0) {
            validationErrors.valueSettings = errors;
        }
    }
    validateWith(action, validationErrors) {
        if (!action || !action.type) {
            return;
        }
        if (!ActionService.WITH_TYPES.includes(action.type)) {
            return;
        }
        const errors = [];
        if (!action.valueSettings || !('with' in action.valueSettings) || action.valueSettings.with === null) {
            errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
        }
        if (errors.length > 0) {
            validationErrors.with = errors;
        }
    }
    validateSeparator(action, validationErrors) {
        if (!action || !action.type) {
            return;
        }
        if (!ActionService.SEPARATOR_TYPES.includes(action.type)) {
            return;
        }
        const errors = [];
        if (!action.valueSettings || !('separator' in action.valueSettings) || action.valueSettings.separator === null) {
            errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
        }
        if (errors.length > 0) {
            validationErrors.with = errors;
        }
    }
}
//# sourceMappingURL=action-validator.js.map